import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Suspense, lazy, useContext } from "react";

import { AuthContext } from "./Components/Context/AuthContext/AuthContext";
import Footer from "./Components/Footer/Footer";
import NavBar from "./Components/Header/NavBar";
import PageLoading from "./Components/Suspense/Loadings/PageLoading/PageLoading";
import ScrollUp from "./Components/ScrollUp/ScrollUp";

const Login = lazy(() =>
  import("./Components/BackEnd/Admin/Authentication/Login/Login.jsx")
);
const Home = lazy(() => import("./Components/Pages/Home/Home.jsx"));
const Categories = lazy(() =>
  import("./Components/Pages/Categories/Categories.jsx")
);
const Category = lazy(() => import("./Components/Pages/Category/Category.jsx"));
const Product = lazy(() => import("./Components/Pages/Product/Product.jsx"));
const PrivacyPolicy = lazy(() =>
  import("./Components/Pages/PrivacyPolicy/PrivacyPolicy.jsx")
);
const ContactUs = lazy(() => import("./Components/Pages/ContactUs/ContactUs.jsx"));
const AboutUs = lazy(() => import("./Components/Pages/AboutUs/AboutUs.jsx"));
const AddProducts = lazy(() =>
  import("./Components/BackEnd/Admin/Add/AddProducts/AddProducts.jsx")
);
const EditProducts = lazy(() =>
  import("./Components/BackEnd/Admin/Edit/Products/EditProducts.jsx")
);
const EditCategories = lazy(() => import("./Components/BackEnd/Admin/Edit/Categories/EditCategories.jsx"));
const AdminControlPanel = lazy(() =>
  import("./Components/BackEnd/Admin/AdminControlPanl/AdminControlPanel.jsx")
);
const Products = lazy(() => import("./Components/Pages/Products/Products.jsx"));
const ProtectedRoute = ({ children }) => {
  const Location = useLocation();
  const { currentUser } = useContext(AuthContext);
  if (!currentUser) {
    return (
      <Navigate to="/adminloginroute" state={{ from: Location }} replace />
    );
  }
  return children;
};
function App() {
  return (
    <div className="flex w-screen items-center justify-center flex-col font-tajawal bg-stone-200">
      <BrowserRouter>
        <ScrollUp />
        <NavBar />
        <Suspense fallback={<PageLoading />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/adminLoginRoute" element={<Login />} />
            <Route
              path="/admincontrolpanelroute"
              index
              element={
                <ProtectedRoute>
                  <AdminControlPanel />
                </ProtectedRoute>
              }
            />
            <Route
              path="/adminaddproductsroute"
              indx
              element={
                <ProtectedRoute>
                  <AddProducts />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admineditproductsroute"
              indx
              element={
                <ProtectedRoute>
                  <EditProducts />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admineditcategoriesroute"
              indx
              element={
                <ProtectedRoute>
                  <EditCategories />
                </ProtectedRoute>
              }
            />
            <Route path="/categories/:category" element={<Category />} />
            <Route
              path="/categories/:category/:productId"
              element={<Product />}
            />
            <Route path="/:productId" element={<Product />} />
            <Route path="/products/category/:productId" element={<Product />} />
            <Route path="/products/:productId" element={<Product />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/products" element={<Products />} />
          </Routes>
        </Suspense>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
